/* eslint-disable react/jsx-no-bind */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable max-len */
import Spinner from '@atlaskit/spinner';
import React, { ChangeEvent, FC, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { accountService } from '../../../../../../service';
import { ModalSelectGroupCall } from '../ModalSelectGroupCall';

type EditContactProps = {
    onClose: () => any,
    open?: boolean,
    user: any,
};

export const EditContact: FC<EditContactProps> = ({ open, onClose, user }) => {
    const [ userInfo, setUserInfo ] = useState(user);
    const [ error, setError ] = useState({});
    const [ loading, setLoading ] = useState(false);
    const [ openConfirm, setOpenConfirm ] = useState(false);
    const [ openConfirmDelete, setOpenConfirmDelete ] = useState(false);
    const dispatch = useDispatch();

    const onChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        setUserInfo(pre => {
            return {
                ...pre,
                [event.target.name]: event.target.value
            };
        });
        setError(pre => {
            return {
                ...pre,
                [event.target.name]: undefined,
                errorMessage: undefined
            };
        });
    }, []);

    const onSave = async () => {
        setLoading(true);
        try {
            await accountService
                .editContact(userInfo.id, userInfo)
                .then(async () => {
                    const res = await accountService.getDataContact();

                    dispatch({
                        type: 'USER_CONTACT',
                        value: res
                    });
                });
        } catch (e) {
            if (e?.response?.status === 403) {
                setError(pre => {
                    return {
                        ...pre,
                        messageError: 'You don\'t have permission'
                    };
                });
            }
        } finally {
            setLoading(false);
            setOpenConfirm(false);
        }
    };

    const onDelete = useCallback(async () => {
        setLoading(true);
        try {
            await accountService.removeContact(userInfo.id);
            const res = await accountService.getDataContact();

            dispatch({
                type: 'USER_CONTACT',
                value: res
            });
        } catch (e) {
            if (e?.response?.status === 403) {
                setError(pre => {
                    return {
                        ...pre,
                        messageError: 'You don\'t have permission'
                    };
                });
            }
        } finally {
            setLoading(false);
        }
    }, [ userInfo.id ]);

    const handleSubmit = useCallback(() => {
        if (openConfirmDelete) {
            onDelete();

            return;
        }
        if (loading) {
            return;
        }
        onSave();
    }, [ userInfo, openConfirmDelete ]);

    const onCloseModal = useCallback(() => {
        onClose?.();
        setError({});
    }, []);

    const openConfirmSave = () => {
        const newErrors = {};
        const regSpecial = /[`!@#$%^&*()_+=[\]{};':"\\|,.<>/?~]/;
        const regSpecialSpace = /[ `!@#$%^&*()_+=[\]{};':"\\|,.<>/?~]/;
        const regNumber = /[0-9]/;
        const regText = /[a-z]|[A-Z]/;
        const regEmail
            = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

        if (!userInfo.firstName) {
            newErrors.firstName = 'Please enter your first name !';
        } else if (
            regSpecial.test(userInfo.firstName)
            || regNumber.test(userInfo.firstName)
        ) {
            newErrors.firstName
                = 'No numbers or special characters are allowed.';
        } else if (userInfo.firstName.length > 30) {
            newErrors.firstName = 'Maximum length is 30 characters.';
        }
        if (userInfo.phoneNumber) {
            if (
                regText.test(userInfo.phoneNumber)
                || regSpecialSpace.test(userInfo.phoneNumber)
            ) {
                newErrors.phoneNumber = 'Please enter a valid phone number';
            }
        }
        if (!userInfo.lastName) {
            newErrors.lastName = 'Please enter your last name !';
        } else if (
            regSpecial.test(userInfo.lastName)
            || regNumber.test(userInfo.lastName)
        ) {
            newErrors.lastName
                = 'No numbers or special characters are allowed.';
        } else if (userInfo.lastName.length > 30) {
            newErrors.lastName = 'Maximum length is 30 characters.';
        }
        if (userInfo.email) {
            if (!regEmail.test(userInfo.email)) {
                newErrors.email = 'Check the format of the email you entered';
            } else if (userInfo.email.length > 70) {
                newErrors.email = 'Maximum length is 70 characters.';
            }
        }
        if (!(userInfo.email || userInfo.phoneNumber)) {
            newErrors.email = 'Please enter your email !';
            newErrors.phoneNumber = 'Please enter your phone number !';
        }
        if (Object.keys(newErrors).find(key => newErrors[key])) {
            setError(newErrors);
        }
        if (Object.keys(newErrors).find(key => newErrors[key])) {
            return;
        }
        setOpenConfirm(true);
    };


    return (
        <>
            <ModalSelectGroupCall
                onClose = { onCloseModal }
                open = { open }
                style = {{
                    transition: 'all 0.3s',
                    opacity: Number(!(openConfirm || openConfirmDelete))
                }}
                width = { 360 }>
                <div className = 'o-create-group-title'>
                    <p>Edit Contact</p>
                </div>
                <div className = { 'o-add-contact-popup--inputs' }>
                    <input
                        className = { `o-add-contact-popup--inputs--input ${
                            error.firstName ? 'o-add-contact-popup--error' : ''
                        }` }
                        name = 'firstName'
                        onChange = { onChange }
                        placeholder = { 'First name' }
                        type = 'text'
                        value = { userInfo.firstName } />
                    {error.firstName ? (
                        <span
                            className = {
                                'o-add-contact-popup--inputs--label-error'
                            }>
                            {error.firstName}
                        </span>
                    ) : null}
                    <input
                        className = { `o-add-contact-popup--inputs--input ${
                            error.lastName ? 'o-add-contact-popup--error' : ''
                        }` }
                        name = 'lastName'
                        onChange = { onChange }
                        placeholder = { 'Last name' }
                        type = 'text'
                        value = { userInfo.lastName } />
                    {error.lastName ? (
                        <span
                            className = {
                                'o-add-contact-popup--inputs--label-error'
                            }>
                            {error.lastName}
                        </span>
                    ) : null}
                    <input
                        className = { `o-add-contact-popup--inputs--input ${
                            error.phoneNumber
                                ? 'o-add-contact-popup--error'
                                : ''
                        }` }
                        name = 'phoneNumber'
                        onChange = { onChange }
                        placeholder = { 'Phone number' }
                        type = 'text'
                        value = { userInfo.phoneNumber } />
                    {error.phoneNumber ? (
                        <span
                            className = {
                                'o-add-contact-popup--inputs--label-error'
                            }>
                            {error.phoneNumber}
                        </span>
                    ) : null}
                    <input
                        className = { `o-add-contact-popup--inputs--input ${
                            error.email ? 'o-add-contact-popup--error' : ''
                        }` }
                        name = 'email'
                        onChange = { onChange }
                        placeholder = { 'E-mail' }
                        type = 'text'
                        value = { userInfo.email } />
                    {error.email ? (
                        <span
                            className = {
                                'o-add-contact-popup--inputs--label-error'
                            }>
                            {error.email}
                        </span>
                    ) : null}
                </div>
                {error.messageError ? (
                    <span
                        className = { 'o-add-contact-popup--inputs--label-error' }>
                        {error.messageError}
                    </span>
                ) : null}
                <div className = { 'o-add-contact-popup--buttons mt-10' }>
                    <div
                        className = { 'o-add-contact-popup--delete' }
                        onClick = { () => setOpenConfirmDelete(true) }>
                        {loading ? <Spinner /> : 'Delete'}
                    </div>
                    <div
                        className = { 'o-add-contact-popup--cancel' }
                        onClick = { onClose }>
                        Cancel
                    </div>
                    <div
                        className = { 'o-add-contact-popup--save' }
                        onClick = { openConfirmSave }>
                        Save
                    </div>
                </div>
            </ModalSelectGroupCall>
            <ModalSelectGroupCall
                closeable = { false }
                open = { openConfirm || openConfirmDelete }>
                <div
                    style = {{
                        color: '#000000',
                        fontSize: 20
                    }}>
                    {openConfirm ? 'Are you sure you want to update this contact?' : 'Are you sure you want to delete this contact?'}
                </div>
                <div
                    className = { 'o-add-contact-popup--buttons mt-15' }
                    style = {{ justifyContent: 'center' }}>
                    <div
                        className = { 'o-add-contact-popup--cancel' }
                        onClick = { () => {
                            setOpenConfirm(false);
                            setOpenConfirmDelete(false);
                        } }>
                        Cancel
                    </div>
                    <div
                        className = { 'o-add-contact-popup--save ml-10' }
                        onClick = { handleSubmit }>
                        {loading ? <Spinner /> : 'Continue'}
                    </div>
                </div>
            </ModalSelectGroupCall>
        </>
    );
};
